import { render, staticRenderFns } from "./ProjectModulesConfigModal.vue?vue&type=template&id=c141b4d2&scoped=true"
import script from "./ProjectModulesConfigModal.vue?vue&type=script&lang=js"
export * from "./ProjectModulesConfigModal.vue?vue&type=script&lang=js"
import style0 from "./ProjectModulesConfigModal.vue?vue&type=style&index=0&id=c141b4d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c141b4d2",
  null
  
)

export default component.exports